import { Component,  OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { LangService } from 'src/app/service/lang.service';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements OnInit {
  private subscriptions: Subscription;
  dir: string = '';

  constructor(public translate: TranslateService, public langser: LangService) {
    this.subscriptions = this.langser.getData().subscribe(value => {
      this.setValue(value);
    });
  }

  ngOnInit(): void {
    const lang = this.langser.getLang();
    this.setValue(lang);
  }

  setValue(lang: string) {
    this.dir = lang === 'ar' ? 'rtl' : 'ltr';
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  enquiryForm() {
    document
      .getElementById("contactus")
      ?.scrollIntoView({ behavior: "smooth" });
  }
}
